import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Users, Award, Clock, MapPin, Sparkles, Heart, Star } from 'lucide-react';
const stats = [{
  number: '500+',
  label: '优质伴游女郎',
  icon: Users
}, {
  number: '10+',
  label: '覆盖国家地区',
  icon: Globe
}, {
  number: '5000+',
  label: '成功服务次数',
  icon: Heart
}, {
  number: '24/7',
  label: '全天候在线客服',
  icon: Clock
}];
const features = [{
  icon: Award,
  title: '严选全球佳丽',
  desc: 'IsYou 汇集来自欧美、日韩、越南、中国及东南亚等地的顶级伴游女郎。每一位佳丽均经过严格的形象审核、身份核验与专业面试，确保为您呈现最真实、最优质的陪伴体验。'
}, {
  icon: Sparkles,
  title: '高端定制服务',
  desc: '无论是商务宴请、社交派对、旅行陪伴还是私人约会，IsYou 都能根据您的需求精准匹配最合适的伴游女郎，提供一对一的专属定制服务，让每一次邂逅都成为难忘的回忆。'
}, {
  icon: MapPin,
  title: '深耕新加坡市场',
  desc: '作为新加坡本地领先的高端伴游平台，IsYou 深谙本地文化与法规，在新加坡拥有广泛的服务网络和良好的口碑，是众多精英人士的首选伴游服务品牌。'
}, {
  icon: Star,
  title: '口碑与信赖',
  desc: '凭借卓越的服务品质和严格的安全保障，IsYou 赢得了超过5000位客户的信赖与好评。我们始终坚持"客户至上、品质为先"的服务理念，致力于打造行业标杆。'
}];
export function AboutSection() {
  return <section id="about" className="py-24 bg-dark-800 relative overflow-hidden" data-id="element-10">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[150px]" data-id="element-11"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gold-500/5 rounded-full blur-[120px]" data-id="element-12"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-13">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-14">
          <span className="inline-block py-1 px-3 border border-gold-500/30 rounded-full text-gold-500 text-xs tracking-[0.2em] uppercase mb-6 bg-gold-500/5" data-id="element-15">
            About IsYou
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-16">
            关于 <span className="text-gold-500" data-id="element-17">IsYou</span> 是您网
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full mb-8" data-id="element-18"></div>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-19">
            IsYou（是您网）创立于新加坡，是一家专注于高端伴游服务的专业平台。
            我们致力于为全球精英人士提供安全、私密、优质的伴游体验，
            让每一位客户都能在新加坡找到最理想的陪伴。
          </p>
        </motion.div>

        {/* Brand Story */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-dark-900 border border-white/5 rounded-2xl p-8 md:p-12 mb-16" data-id="element-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-21">
            <div data-id="element-22">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-white mb-6" data-id="element-23">
                我们的<span className="text-gold-500" data-id="element-24">使命</span>
              </h3>
              <p className="text-gray-400 leading-relaxed mb-4" data-id="element-25">
                在IsYou，我们相信每一次相遇都应该是美好的。我们的使命是打破传统伴游行业的信息不对称，
                通过严格的审核机制和专业的服务体系，为客户与伴游女郎之间搭建一座安全、透明、高效的桥梁。
              </p>
              <p className="text-gray-400 leading-relaxed mb-4" data-id="element-26">
                我们深知，选择伴游服务需要极大的信任。因此，IsYou
                从创立之初便将"真实、安全、尊重"
                作为核心价值观，每一位入驻平台的伴游女郎都必须通过真人视频核验、身份信息审核和线下面试三重认证。
              </p>
              <p className="text-gray-400 leading-relaxed" data-id="element-27">
                我们承诺：您在IsYou看到的每一张照片、每一段介绍都是真实可靠的，
                让您可以放心选择，安心赴约。
              </p>
            </div>
            <div className="relative" data-id="element-28">
              <div className="bg-dark-800 border border-white/10 rounded-xl p-8 space-y-6" data-id="element-29">
                <div className="flex items-center gap-4" data-id="element-30">
                  <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-31">
                    <span className="text-gold-500 font-serif font-bold text-lg" data-id="element-32">
                      1
                    </span>
                  </div>
                  <div data-id="element-33">
                    <h4 className="text-white font-bold" data-id="element-34">真实可靠</h4>
                    <p className="text-gray-500 text-sm" data-id="element-35">
                      三重认证，杜绝虚假信息
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-36">
                  <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-37">
                    <span className="text-gold-500 font-serif font-bold text-lg" data-id="element-38">
                      2
                    </span>
                  </div>
                  <div data-id="element-39">
                    <h4 className="text-white font-bold" data-id="element-40">安全私密</h4>
                    <p className="text-gray-500 text-sm" data-id="element-41">
                      端到端加密，保护您的隐私
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-42">
                  <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-43">
                    <span className="text-gold-500 font-serif font-bold text-lg" data-id="element-44">
                      3
                    </span>
                  </div>
                  <div data-id="element-45">
                    <h4 className="text-white font-bold" data-id="element-46">尊重至上</h4>
                    <p className="text-gray-500 text-sm" data-id="element-47">
                      尊重每一位客户与伴游的权益
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Stats Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16" data-id="element-48">
          {stats.map((stat, index) => <div key={index} className="bg-dark-900 border border-white/5 rounded-xl p-6 text-center" data-id="element-49">
              <stat.icon className="w-6 h-6 text-gold-500 mx-auto mb-3" data-id="element-50" />
              <div className="text-3xl md:text-4xl font-serif font-bold text-gold-500 mb-1" data-id="element-51">
                {stat.number}
              </div>
              <div className="text-gray-400 text-sm" data-id="element-52">{stat.label}</div>
            </div>)}
        </motion.div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-53">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-900 border border-white/5 rounded-xl p-8 hover:border-gold-500/20 transition-colors duration-300" data-id="element-54">
              <div className="w-12 h-12 bg-gold-500/10 rounded-lg flex items-center justify-center mb-5" data-id="element-55">
                <feature.icon className="w-6 h-6 text-gold-500" data-id="element-56" />
              </div>
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-57">
                {feature.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-58">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Service Coverage */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 text-center" data-id="element-59">
          <h3 className="text-2xl font-serif font-bold text-white mb-8" data-id="element-60">
            服务覆盖 <span className="text-gold-500" data-id="element-61">·</span> 全球佳丽
          </h3>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-62">
            {['🇺🇸 欧美', '🇯🇵 日本', '🇰🇷 韩国', '🇻🇳 越南', '🇨🇳 中国', '🇹🇭 泰国', '🇲🇾 马来西亚', '🇷🇺 俄罗斯', '🇧🇷 巴西', '🇬🇧 英国'].map(region => <span key={region} className="px-4 py-2 bg-dark-900 border border-white/10 rounded-full text-sm text-gray-300" data-id="element-63">
                {region}
              </span>)}
          </div>
          <p className="text-gray-500 text-sm mt-6" data-id="element-64">
            IsYou 持续拓展全球伴游资源，为您带来更多元化的选择
          </p>
        </motion.div>

        {/* SEO Rich Content Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-20 border-t border-white/5 pt-16" data-id="element-65">
          <div className="max-w-4xl mx-auto" data-id="element-66">
            <h3 className="text-2xl font-serif font-bold text-white mb-8 text-center" data-id="element-67">
              新加坡是您网 <span className="text-gold-500" data-id="element-68">·</span>{' '}
              您的专属伴游平台
            </h3>

            <div className="space-y-6 text-gray-400 text-sm leading-relaxed" data-id="element-69">
              <p data-id="element-70">
                <strong className="text-white" data-id="element-71">新加坡是您网（IsYou）</strong>
                是新加坡首屈一指的高端伴游服务平台，专为追求品质生活的精英人士打造。作为新加坡伴游行业的领军品牌，IsYou是您网汇集了来自全球各地的优质伴游女郎，包括欧美伴游、日本伴游、韩国伴游、越南伴游、中国伴游、泰国伴游、马来西亚伴游等，为您提供最丰富多元的选择。
              </p>

              <p data-id="element-72">
                在新加坡寻找高端伴游服务？IsYou是您网是您的最佳选择。我们的新加坡伴游服务涵盖商务陪同、社交派对、旅行伴游、私人约会等多种场景。每一位在IsYou是您网注册的伴游女郎都经过严格的三重认证——真人视频核验、身份信息审核和线下面试，确保您看到的每一张照片和每一段介绍都真实可靠，杜绝照骗。
              </p>

              <p data-id="element-73">
                IsYou是您网的核心优势在于
                <strong className="text-white" data-id="element-74">安全、真实、私密</strong>
                。我们采用先进的端到端加密技术保护客户隐私，所有个人信息和行程安排均严格保密。同时，IsYou是您网独创的"见面满意付款"模式，让您在与伴游女郎见面确认满意后再付款，最大程度保障您的权益，让您无后顾之忧。
              </p>

              <p data-id="element-75">
                无论您是来新加坡出差的商务人士，还是旅居新加坡的高端客户，IsYou新加坡是您网都能为您精准匹配最合适的伴游女郎。我们的专业客服团队24小时在线，随时为您提供一对一的咨询和预约服务，确保每一次体验都完美无瑕。
              </p>

              <p data-id="element-76">
                选择IsYou新加坡是您网，就是选择品质与信赖。我们已成功服务超过5000位客户，覆盖10多个国家和地区，拥有500余位经过严格筛选的优质伴游女郎。IsYou是您网始终秉持"客户至上、品质为先、安全第一"的服务理念，致力于成为新加坡乃至亚太地区最受信赖的高端伴游服务平台。
              </p>

              <p data-id="element-77">
                <strong className="text-white" data-id="element-78">
                  新加坡伴游就选IsYou是您网
                </strong>
                ——真人核验、安全可靠、见面满意付款。立即访问我们的官网或加入我们的Telegram频道，开启您的尊贵伴游体验。IsYou是您网，让每一次邂逅都成为美好回忆。
              </p>
            </div>

            {/* SEO Keywords Tags */}
            <div className="mt-10 flex flex-wrap gap-2 justify-center" data-id="element-79">
              {['新加坡伴游', '新加坡是您网', 'IsYou伴游', '高端伴游服务', '新加坡伴游女郎', '欧美伴游', '日本伴游', '韩国伴游', '越南伴游', '中国伴游', '新加坡约会', '商务伴游', '真人核验伴游', '安全伴游平台', 'Singapore escort', 'Singapore companion', '新加坡高端陪伴'].map(tag => <span key={tag} className="px-3 py-1 bg-dark-900/50 border border-white/5 rounded-full text-[11px] text-gray-500" data-id="element-80">
                  {tag}
                </span>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}